export const getIPFSStorageUrl = (hash: string): string => `https://${hash}.ipfs.nftstorage.link`;
